module.exports = __webpack_public_path__ + "img/Villa_Borna_5.d60bebef.jpg";